import { DisplayOnlyCalendar } from "components/DatePicker/DisplayOnlyCalendar";
import React from "react";

interface Props {
  repetitions: number
  interval: server.dto.CopyIntervals
  realStartDate: moment.Moment
}

const RepetitionCalendar = (props: Props) => {
  const highlightedDates = React.useMemo(() => {
    const dates: moment.Moment[] = [];
    for (let i = 0; i < props.repetitions; i++) {
      let nextMoment;
      switch (props.interval) {
        case "repeatPerDay": nextMoment = props.realStartDate.clone().add((i + 1), "days"); break;
        case "repeatPerWeek": nextMoment = props.realStartDate.clone().add((i + 1) * 7, "days"); break;
        case "repeatPerTwoWeeks": nextMoment = props.realStartDate.clone().add((i + 1) * 14, "days"); break;
        case "repeatPerMonth": nextMoment = props.realStartDate.clone().add((i + 1), "months"); break;
        case "repeatPerQuarter": nextMoment = props.realStartDate.clone().add((i + 1) * 3, "months"); break;
        case "repeatPerYear": nextMoment = props.realStartDate.clone().add((i + 1) * 12, "months"); break;
        default: throw new Error("Invalid interval: " + props.interval);
      }
      dates.push(nextMoment);
    }

    return dates;
  }, [props.repetitions, props.interval, props.realStartDate]);

  return <DisplayOnlyCalendar
    selectedDates={highlightedDates}
    monthsToShow={3}
    startDate={props.realStartDate}
  />
};

export default RepetitionCalendar;